const initialState = {
  expertRankData: {},
  viewCountData: {},
  slaComplianceData: {},
  expertScore: {},
  avgResTime: {},
  recentRatings: [],
  questionText: "",
  answerText: "",
  questionTextDetails: {},
  bestRatingsData: [],
  worstRatingsData: [],
  betterRatingsData: [],
  domainByExpert: [],
  ratingsByGroup: {},
  totalAnsweredTrend: [],
  expertScoreTrend: [],
  slaComplianceTrend: [],
  responseTimeTrend: [],
  isLoading: false,
  inlineImagesData: [],
  getDataForViewCountPerUser:[],
  getDataForViewCountPerGeo:[]
};

const myStatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'loadingDataExpertMyStat':
      state = { ...state, isLoading: action.payload };
      return state;
    case 'getExpertRank':
      state = { ...state, expertRankData: action.payload };
      return state;
    case 'getViewCountStatsData':
      state = { ...state, viewCountData: action.payload };
      return state;
    case 'getSLAComplianceData':
      state = { ...state, slaComplianceData: action.payload };
      return state;
    case 'getExpertScore':
      state = { ...state, expertScore: action.payload };
      return state;
    case 'getAvgResTime':
      state = { ...state, avgResTime: action.payload };
      return state;
    case 'getRecentRatings':
      state = { ...state, recentRatings: action.payload };
      return state;
    case 'getQuestionText':
      state = { ...state, questionText: action.payload };
      return state;
    case 'getAnswerText':
      state = { ...state, answerText: action.payload };
      return state;
    case 'getQuestionTextData':
      state = { ...state, questionTextDetails: action.payload };
      return state;
    case 'getWorstRatingsData':
      state = { ...state, worstRatingsData: action.payload };
      return state;
    case 'getBestRatingsData':
      state = { ...state, bestRatingsData: action.payload };
      return state;
    case 'getBetterRatingsData':
      state = { ...state, betterRatingsData: action.payload };
      return state;
    case 'getDomainByExpertData':
      state = { ...state, domainByExpert: action.payload };
      return state;
    case 'getRatingsByGroupData':
      state = { ...state, ratingsByGroup: action.payload };
      return state;
    case 'getTotalAnsweredTrendData':
      state = { ...state, totalAnsweredTrend: action.payload };
      return state;
    case 'getExpertScoreTrendDataExpertStats':
      state = { ...state, expertScoreTrend: action.payload };
      return state;
    case 'getSlaComplianceTrendData':
      const sortedData = action.payload.sort((a, b) => new Date(a.week.weekStart) - new Date(b.week.weekStart));
      state = { ...state, slaComplianceTrend: sortedData };
      return state;
    case 'getResponseTimeTrendData':
      state = { ...state, responseTimeTrend: action.payload };
      return state;
    case 'inlineImagesData':
      state = { ...state, inlineImagesData: action.payload };
      return state;
    case 'getDataForExpertAnswersViewStatistics':
        let newData = Object.entries(action.payload?.userType || {}).map(([name, value]) => ({ name, value }));
        let newData2 = Object.entries(action.payload?.geo || {}).map(([name, value]) => ({ name, value }));
        state = {...state,getDataForViewCountPerUser:newData};
        state = {...state, getDataForViewCountPerGeo:newData2};
      return state;
    default:
      return state;
  }
}
export default myStatsReducer;
